import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Signal pour le filet de sécurité de public/index.html : le code principal
// a bien démarré (sinon, au chargement de la page, il propose « Recharger »
// au lieu d'un écran blanc).
document.documentElement.setAttribute("data-trm-app", "ok");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
